<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card dense>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Gericht bearbeiten</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <MealForm />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import MealForm from "@/components/meals/MealForm";

export default {
  name: "MealEdit",
  components: { MealForm },
  data: () => ({}),

  methods: {},
  computed: {}
};
</script>
<style scoped></style>
